/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { Observable, tap } from 'rxjs';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';
import { isPlatformBrowser } from '@angular/common';

dayjs.extend(utc);
dayjs.extend(tz);

@Injectable({
  providedIn: 'root'
})
export class SetInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
    private _encryptionSerivce: EncryptionService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    // Todo
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleRequest(req: HttpRequest<any>) {
    let storageKey;
    let token : string | null = null;
    let language: any = 'en';

    if (isPlatformBrowser(this.platformId)) {
      storageKey = localStorage.getItem(environment.storageKey);
      language = localStorage.getItem(environment.langKey);
      token = storageKey ? storageKey : null;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let authReq: any;

    const headers = {
      'Content-Type': 'application/json',
      authorization: token ? `Bearer ${token}` : '',
      date: dayjs.default().valueOf().toString()
    };

    // **Set the specific authorization token only for this route**
    if (req.url.includes('wp-json/custom/v1/')) {
      const wordPressHeaders = {
        'Content-Type': 'application/json',
        authorization: token ? `Basic  ${token}` : ''
      };
      wordPressHeaders.authorization =
      'Basic Y2tfMWE3OTFhNjMxMWYzYzkxNDg3NmNmZDA2YTM3ZWQyZjQ6Y3NfMTQ1YWM5OWI4MmVhODQ0N2JlNjNmNGEzMDgyZTU1NmY=';

      authReq = req.clone({
        headers: new HttpHeaders(wordPressHeaders)
      });
      return authReq;
    }

    if (req.url.includes('user/resetPassword')) {
      this._authService.resetTokenSubject.subscribe((res: string) => {
        headers.authorization = `Bearer ${res}`;
      });
    }

    // eslint-disable-next-line prefer-const
    authReq = req.clone({
      headers: new HttpHeaders({
        hash: this._encryptionSerivce.encryptHeaders(headers),
        deviceType: 'web',
        Lang: language ? language : 'en'
      })
    });

    if (isPlatformBrowser(this.platformId)) {
      const language = localStorage.getItem(environment.langKey);
      // eslint-disable-next-line prefer-const
      authReq = req.clone({
        headers: new HttpHeaders({
          hash: this._encryptionSerivce.encryptHeaders(headers),
          deviceType: 'web',
          Lang: language ? language : 'en'
        })
      });
    }

    if (
      req.method.toLowerCase() === 'post' ||
      req.method.toLowerCase() === 'put'
    ) {
      if (req.url.includes('upload/uploadDoc')) {
        // Do nothing
      } else {

        authReq['body'] = {

          hash: this._encryptionSerivce.encryptionPayload(
            JSON.stringify(authReq.body)
          )
        };

      }
    }
    return authReq;
  }
}
